/**
 * @fileoverview Class composition helper for source-owned shadcn-style components.
 * @provides cn for conditional Tailwind class merging.
 * @usedBy Every design-system primitive and composed pattern.
 * @uses clsx and tailwind-merge.
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
